import type { HistoryItem } from "@algolia/autocomplete-plugin-recent-searches/dist/esm/types";
import { allResultsLinkStyles } from "./AutoCompletePanelStyles";
import { NextLink } from "@ui/components/navigation/link/NextLink";
import { Flex } from "@ui/components/layout/flex/Flex";
import type { FlexProps } from "@ui/components/layout/flex/Flex";
import { ECCOIcon } from "@ui/components/media-and-icons/ecco-icon/ECCOIcon";

interface AllResultsLinkProps extends Omit<FlexProps, "onClick"> {
    url: string;
    label: string;
    item?: HistoryItem;
    onClick?: (item: HistoryItem) => void;
}

export const AllResultsLink = ({ url, label, item, onClick, ...rest }: AllResultsLinkProps) => {
    return (
        <Flex gap={2} {...rest}>
            <NextLink
                {...allResultsLinkStyles}
                href={url}
                onClick={() => {
                    item && onClick?.(item);
                }}
            >
                {label}
                <ECCOIcon ml={2} name="arrow-right" />
            </NextLink>
        </Flex>
    );
};
